import React from 'react';
import './styles.css';

const StrukturOrganisasi = ({ content }) => {
  const imageUrl = content?.organizationChartUrl || "https://via.placeholder.com/1024x576.png?text=Gambar+Struktur+Organisasi";

  return (
    <section className="section struktur-section">
      <div className="container">
        <h2>Struktur Organisasi</h2>
        <div className="struktur-image-container">
          <img src={imageUrl} alt="Struktur Organisasi SMK Pariwisata Sumbangsih" className="struktur-image" />
        </div>
      </div>
    </section>
  );
};

export default StrukturOrganisasi;